import http from './http'

const bookingRoute = '/booking/'
const searchRoute = '/search/'

export default {
    async search (bookingSearch) {
        return http.post(searchRoute, bookingSearch)
    },
    async getBookingDetail (bookingId) {
        return http.get(bookingRoute + bookingId + '/detail')
    },
    async getCustomer (bookingId) {
        return http.get(bookingRoute + bookingId + '/customer')
    },
    async getVehicle (bookingId) {
        return http.get(bookingRoute + bookingId + '/vehicle')
    },
    async getFlightDetails (bookingId) {
        return http.get(bookingRoute + bookingId + '/flight')
    },
    async getBookingHistory (bookingId) {
        return http.get(bookingRoute + bookingId + '/history')
    },
    async getBarrierStatus (bookingId) {
        return http.get(bookingRoute + bookingId + '/barrier-status')
    },
    async getNotes (bookingId) {
        return http.get(bookingRoute + bookingId + '/notes')
    },
    async getPaymentDetail (bookingId) {
        return http.get(bookingRoute + bookingId + '/payment-detail')
    },
    async getPaymentHistory (bookingId) {
        return http.get(bookingRoute + bookingId + '/payment-history')
    },
    async getProduct (bookingId) {
        return http.get(bookingRoute + bookingId + '/product')
    },
    async getProductExtras (bookingId) {
        return http.get(bookingRoute + bookingId + '/extras')
    },
    async getAudit (bookingId) {
        return http.get(bookingRoute + bookingId + '/audit')
    },
    async getBookingType (bookingId) {
        return http.get(bookingRoute + bookingId + '/type')
    },
    async updateCustomer (bookingId, customer) {
        return http.put(bookingRoute + bookingId + '/customer', customer)
    },
    async addNote (bookingId, note) {
        return http.post(bookingRoute + bookingId + '/note', note)
    },
    async sendConfirmationEmail (bookingId, email) {
        return http.post(bookingRoute + bookingId + '/confirmation-email', {
            email: email
        })
    },
    async updateVehicle (bookingId, vehicle) {
        return http.put(bookingRoute + bookingId + '/vehicle', vehicle)
    },
    async updateFlight (bookingId, flightDetails) {
        return http.put(bookingRoute + bookingId + '/flight', flightDetails)
    },
    async updateProductDate (bookingId, entryDate, exitDate) {
        return http.put(bookingRoute + bookingId + '/product-date', {
            entryDate,
            exitDate
        })
    },
    async reserveBooking(booking) {
        const bookingReserveRequest = {
            airportCode: booking.airportCode,
            entryDateTime: booking.entryDateTime,
            exitDateTime: booking.exitDateTime,
            promotionCode: booking.promotionCode,
            affiliateCode: booking.affiliateCode,
            terminalId: booking.terminalId,
            bookingId: booking.bookingId,
            parkingId: booking.parkingId,
            bundleId: booking.bundleId,
            extras: booking.extras.map(extra => sanitiseBookingExtras(extra))
        };

        return http.post(bookingRoute, bookingReserveRequest)
    },
    async confirmBooking(booking) {
        const bookingConfirmRequest = {
            airportCode: booking.airportCode,
            entryDateTime: booking.entryDateTime,
            exitDateTime: booking.exitDateTime,
            promotionCode: booking.promotionCode,
            affiliateCode: booking.affiliateCode,
            terminalId: booking.terminalId,
            bookingId: booking.bookingId,
            customer: booking.customer,
            paymentSession: booking.paymentSession,
            vehicle: booking.vehicle
        };

        return http.post(`${bookingRoute}${booking.bookingId}/confirm`, bookingConfirmRequest)
    },
    async addExtra (bookingId, extra) {
        return http.post(`${bookingRoute}${bookingId}/extra`, extra)
    },
    async modifyBooking (booking) {
        const modification = {
            ...booking,
            extras: booking.extras.map(e => sanitiseBookingExtras(e))
        }

        return http.put(`${bookingRoute}${booking.bookingId}`, modification)
    },
    async confirmModifyBooking (booking) {
        const confirmation = {
            ...booking,
            extras: booking.extras.map(e => sanitiseBookingExtras(e))
        }
        return http.post(`${bookingRoute}${booking.bookingId}/modify/confirm`, confirmation)
    },
    async cancelBooking (bookingId, cancelDetails) {
        return http.post(`${bookingRoute}${bookingId}/cancel`, cancelDetails)
    },
    async overrideBookingPrice (bookingId, price) {
        return http.post(`${bookingRoute}${bookingId}/OverridePrice`, price)
    },
    async refundBooking (bookingId, amount) {
        return http.post(`${bookingRoute}${bookingId}/refund`, amount)
    },
    async getRefundDetails (bookingId) {
        return http.get(`${bookingRoute}${bookingId}/refund`)
    },
    async getCancellationDetails (bookingId) {
        return http.get(`${bookingRoute}${bookingId}/cancellation-details`)
    },
    async getPaymentSession (paymentSessionUrl) {
        return http.get(paymentSessionUrl)
    }
}

function sanitiseBookingExtras(extra) {
    return {
        id: extra.id,
        name: extra.name,
        offerLines: extra.offerLines.map(offerLine => {
            return {
                id: offerLine.id,
                quantity: offerLine.quantity
            }
        })
    }
}
